<template>
  <div v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.SPORTS) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))">
    <SportsNavigation/>
    <div class="mt-5">
      <v-container style="height:97vh; overflow: hidden; margin-right: 0; margin-left: 0; padding-bottom: 30px; max-width: 100%">
        <v-row style="height: 100%;">
          <v-col md="6" style="height: 100%; padding-left: 24px;">
            <v-toolbar class="mb-3" height="30px" color="#425058" dark>
              <h4>Markets</h4>
            </v-toolbar>
            <SportMarkets/>
          </v-col>
          <v-col md="6" style="">
            <v-toolbar class="mb-3 mt-0" height="30px" color="#425058" dark>
              <h4>Results</h4>
            </v-toolbar>
            <SportResults/>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import SportsNavigation from "../components/SportsNavigation"
import SportMarkets from "../components/SportMarkets"
import SportResults from "../components/SportResults"
import { mapGetters } from 'vuex'
import { accessControlMixin } from '../components/mixins/index'

export default {
  mixins:[accessControlMixin],
  data () {
    return {}
  },
  components: {
    SportsNavigation,
    SportMarkets,
    SportResults
  },
  mounted () {
    if (this.user.roles && (!this.user.roles.includes('*') && !this.userHasResourceAccess(this.RESOURCENAMES.SPORTS) && !this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT))) {
      if (this.$route && this.$route.path !== '/') {
        this.$router.push('/')
      }
    }
  },
  computed: {
    ...mapGetters(['getUserLoggedIn']),
    user () {
      return this.getUserLoggedIn
    }
  },
}
</script>

<style>

</style>